import {toLocalStorage} from '@actions/formulary';

 /**
  * simple utilitaire qui prend le state, le sauvegarde dans le localstorage et
  * return le state
  */
const updateLocalStorageAndReturn = (state) => {
  localStorage.setItem('localState', JSON.stringify(state));
  return state;
}
const AppReducer = (state, action) => {

  const {type, payload} = action;
  let newFormContext = {...state.formDataContext};
  switch (type) {
    case 'NEXT_STEP':
      return updateLocalStorageAndReturn({
        ...state,
        currentStep: state.currentStep + 1,
      });
    case 'PREV_STEP':
      return updateLocalStorageAndReturn({
        ...state,
        currentStep: state.currentStep - 1,
      });

    case 'FIRST_STEP':
      return updateLocalStorageAndReturn({
        ...state,
        currentStep: 2,
      });

    case 'SET_STEP':
      return updateLocalStorageAndReturn({
        ...state,
        currentStep: payload,
      });
    case 'SET_PRELOADED_VALUES': {
      const newData = {};
      //map appropriate keys
      payload.forEach(elem => {
        if (elem?.key === "domain") {
          newData["domainId"] = elem?.value;
          return;
        }
        if (elem?.key === "training") {
          newData["idFormationBitrix"] = elem?.value;
          return;
        }
        newData[elem?.key] = elem?.value;
      })
      return updateLocalStorageAndReturn({
        ...state,
        formDataContext: {
          ...state.formDataContext,
          ...newData
        }
      })

    }

    case 'SET_CONFIG':
      return updateLocalStorageAndReturn({
        ...state,
        currentStep: payload?.currentStep ?? state.currentStep,
        maxStep: payload?.maxStep ?? state.maxStep,
        trainingId: payload?.trainingId ?? state.trainingId,
        trainingName: payload?.trainingName ?? state.trainingName,
        formDataContext: {
          ...state.formDataContext,
          origin: payload?.origin ?? state.formDataContext.origin,
          idFormationBitrix: payload?.trainingId ?? state.formDataContext.idFormationBitrix,
          domainId: payload?.domainId ?? state.formDataContext.domainId,
          //add other values
        },
        phrases: payload?.phrases ?? state.phrases,
        config: payload?.config ?? state.config,
        visibleSteps: payload?.visibleSteps ?? state.visibleSteps,
      });

    case 'SET_COOKIES_UTM':
      return updateLocalStorageAndReturn({
        ...state,
        formDataContext: {
          ...state.formDataContext,
          session_anonyme: payload?.session_anonyme ?? state.formDataContext.session_anonyme ?? '',
          ga_cid: payload?.ga_cid ?? state.formDataContext.ga_cid ?? '',
          fb_fbc: payload?.fb_fbc ?? state.formDataContext.fb_fbc ?? '',
          fb_fbp: payload?.fb_fbp ?? state.formDataContext.fb_fbp ?? '',
        },
      });

    case 'SET_ORIGIN':
      toLocalStorage({origin: payload});
      newFormContext['origin'] = payload;
      return updateLocalStorageAndReturn({
        ...state,
        formDataContext: newFormContext,
        loading: false,
      });
    case 'SET_TRAININGID':
      toLocalStorage({trainingId: payload});
      return updateLocalStorageAndReturn({
        ...state,
        trainingId: payload,
        loading: false,
      });
    case 'SET_TRAININGNAME':
      toLocalStorage({trainingName: payload});
      return updateLocalStorageAndReturn({
        ...state,
        trainingName: payload,
        loading: false,
      });

    // Ajout d'un nouveau reducer qui va nous permettre de mieux setter les infos liées à la formation choisie.
    // Le reducer va directement utiliser le résultat provenant de bitrix
    case 'SET_TRAININGINFOS':
      toLocalStorage({trainingName: payload?.id});
      return updateLocalStorageAndReturn({
        ...state,
        trainingName: payload?.id ?? null,
        trainingNameId: payload?.trainingNameId ?? 0,
        trainingId: payload?.ID_FORMATION_BITRIX ?? null,
        formDataContext: {
          ...state.formDataContext,
          idFormationBitrix: payload?.ID_FORMATION_BITRIX ?? 0,
          hasRequestedAdvice: payload === null ? 1 : 0,
        },
        trainingInfos: {
          typeOfTraining: payload?.type ?? null,
          duration: payload?.PERIODE ?? null,
          availableCpf: payload?.FOAD ?? null,
          prerequisites: payload?.PREREQUIS_TEXTE ?? null,
        },
      });

    case 'UPDATE_FORMDATA':
      const formData = [];
      formData[payload.name] = payload.value;
      toLocalStorage(formData);
      newFormContext[payload.name] = payload.value;
      return updateLocalStorageAndReturn( {
        ...state,
        formDataContext: newFormContext,
        loading: false,
      });

    case 'RESET_FORMDATA':
      const resetState = {
        ...payload,
        trainingId: state.trainingId,
        trainingName: state.trainingName,
        loading: state.loading,
        error: state.error,
        formDataContext: {
          GA_CID: state.formDataContext.GA_CID,
          SESSION_ANONYME: state.formDataContext.SESSION_ANONYME,
          fb_fbc: state.formDataContext.fb_fbc,
          fb_fbp: state.formDataContext.fb_fbp,
          idFormationBitrix: state.formDataContext.idFormationBitrix,
          origin: state.formDataContext.origin,
          u_IP: state.formDataContext.u_IP,
          utm_source: state.formDataContext.utm_source,
          consentPartners: state.formDataContext.consentPartners ?? "off"
        },
      };
      // Reset localStorage variable
      localStorage.removeItem('localState');
      // Return the new reset state
      return updateLocalStorageAndReturn(resetState);

    case 'ERROR_FIELD':
      return updateLocalStorageAndReturn({
        ...state,
        error: payload,
        loading: false,
      });
    default:
      return updateLocalStorageAndReturn(state);
  }
};

export default AppReducer;
